export default "__VITE_ASSET__GlbMij$u__"